import(/* webpackMode: "eager" */ "/app/src/app/complaints/page.tsx");
